import classNames from "classnames";
import React from "react";

import { isDefined } from "@utils/helpers";

import { PhoneNumber } from "@components/General/PhoneNumber/phoneNumber.component";
import { StoreSearchStore } from "@components/Store/StoreSearch/storeSearch.types";
import { StoreDistanceComponent } from "@components/Store/shared/storeDistance/storeDistance.component";

import { useStoreSearchContext } from "../../../storeSearch.context";
import "./storeCard.scss";
import { StoreStatusComponent } from "./storeStatus/storeStatus.component";

type StoreCardProps = {
    store: StoreSearchStore;
};

const StoreCard = ({ store }: StoreCardProps) => {
    const { selectedStore } = useStoreSearchContext();

    const handleOnStoreCardClick = () => location.assign(store.url);

    const addressLines = store.properties.address.lines?.join(", ");
    const addressCity = `${store.properties.address.zipcode} ${store.properties.address.city}`;

    const isSelected =
        isDefined(selectedStore) &&
        store.properties.user_properties.storeId ===
            selectedStore?.properties.user_properties.storeId;

    return (
        <li
            className={classNames(
                "store-card",
                isSelected && "store-card--selected",
            )}
            onClick={handleOnStoreCardClick}
        >
            <p className={"store-card__title"}>
                {store.properties.name}
                {store.distancePromise && (
                    <StoreDistanceComponent
                        distancePromise={store.distancePromise}
                    />
                )}
            </p>
            <StoreStatusComponent storeOpen={store.properties.open} />
            <p className={"m-0"}>
                {addressLines}
                {", "}
                {addressCity}
            </p>
            <p className={"w-auto mb-0"}>
                <PhoneNumber
                    phoneNumber={store.properties.contact.phone}
                    ISOcountryCode={store.properties.address.country_code!}
                    asLink={true}
                />
            </p>
        </li>
    );
};

export { StoreCard };
